import {
  IconBell,
  IconBinocularsGray,
  IconChainLink,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import mainVideo from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/constructionSop/img/1.avif';
import image2 from '@src/assets/images/solution/constructionSop/img/2.avif';
import image3 from '@src/assets/images/solution/constructionSop/img/3.avif';
import image4 from '@src/assets/images/solution/constructionSop/img/4.avif';
import image5 from '@src/assets/images/solution/constructionSop/img/5.avif';
import image6 from '@src/assets/images/solution/constructionSop/img/6.avif';
import image7 from '@src/assets/images/solution/constructionSop/img/7.avif';
import image8 from '@src/assets/images/solution/constructionSop/img/8.avif';

export default {
  type: '건설 솔루션',

  banner: {
    title: '위험 자동 감지와 대응',
    desc: 'SOP에 따라 현장의 위험 상황을 실시간으로 감지하고 자동 대응하며, 모든 이력은 데이터로 저장되어 감사와 보고를 위한 증빙자료로 활용됩니다. 디지털 기술로 안전관리를 효율화하고 사고를 사전에 방지할 수 있습니다.',
  },

  video: {
    title: '표준화된 절차를 기반으로 사고를 자동 감지하고 신속히 대응하세요',
    desc: '작업자의 동선과 위험요소를 실시간으로 감지하고, SOP 기반으로 자동 알림·기록·대응까지 연계되어 안전 조치를 체계화할 수 있습니다. 데이터는 자동 저장되어 향후 분석과 감사에도 유용합니다.',
    play: mainVideo,
  },

  func: [
    {
      theme: '위험 자동 감지 및 실시간 대응',
      title: 'SOP 기반 자동 위험 인식',
      desc: '작업자의 움직임과 주변 환경을 분석하여 SOP에 벗어난 작업을 자동 감지하며, AI 기반 이상 징후도 함께 판단합니다.',
      sub1: '높은 정확도 제공',
      icon1: IconRulerGray,
      sub2: '실시간 현황 파악',
      icon2: IconClockGray,
      image: image1,
    },
    {
      title: '위험 감지 시 SOP 대응 패널 자동 호출',
      desc: '위험 이벤트가 발생하면 해당 작업 유형에 맞는 SOP 대응 절차가 자동으로 팝업됩니다. 대응자는 버튼 하나로 절차를 바로 시작할 수 있어 골든타임 확보에 유리합니다.',
      sub2: '실시간 위치 추적',
      icon1: IconBinocularsGray,
      sub1: '빠른 데이터 연동',
      icon2: IconTvocGray,
      image: image2,
    },
    {
      title: 'CCTV 확인 및 열람기록 자동 저장',
      desc: '위험 발생 구간의 CCTV를 자동으로 호출하고, 열람한 영상과 시간은 모두 자동 기록됩니다. 추후 사고 조사나 법적 증빙자료로 바로 활용 가능합니다.',
      sub1: '실시간 위치 추적',
      icon1: IconBinocularsGray,
      sub2: '높은 정확도 제공',
      icon2: IconRulerGray,
      image: image3,
    },
    {
      title: '모바일 기반 SOP 대응 참여 지원',
      desc: 'PC 없이도 스마트폰으로 SOP 절차에 참여할 수 있어 외부 관리자나 이동 중인 책임자도 실시간으로 대응이 가능합니다. 위급 상황에도 공간 제약 없이 조치를 이어갈 수 있습니다.',
      sub1: '자유로운 범위 설정',
      icon1: IconZoneGray,
      sub2: '여러 구역 설정',
      icon2: IconTagGray,
      image: image4,
    },
    {
      theme: 'SOP 운영 및 커스터마이징 관리',
      title: 'SOP별 대응 현황 시각화',
      desc: '진행 중인 SOP 시나리오별로 현재 단계와 완료 여부가 대시보드에 표시되어, 전체 대응 흐름을 한눈에 파악할 수 있습니다. 관리자는 우선 순위에 따라 추가 인력이나 자원을 배정할 수 있습니다.',
      sub1: '자유로운 범위 설정',
      icon2: IconZoneGray,
      sub2: '여러 구역 설정',
      icon1: IconTagGray,
      image: image5,
    },
    {
      title: '보고서 자동 생성 및 다운로드',
      desc: '대응 이력, 알림 발생 시간, 대응 완료 여부 등 주요 데이터를 기반으로 자동 보고서를 생성하고, PDF 또는 엑셀 형식으로 다운로드할 수 있습니다. 주간·월간 보고에 필요한 시간과 인력을 절감할 수 있습니다.',
      sub1: '높은 정확도 제공',
      icon1: IconZoneGray,
      sub2: '여러 구역 설정',
      icon2: IconTagGray,
      image: image6,
    },
    {
      title: '조건 기반 알림 시나리오 생성',
      desc: '온도, 가스, 위치, 동작 상태 등의 조건을 조합하여 맞춤 알림 규칙을 생성할 수 있습니다. 이를 통해 다양한 IoT 센서와 연동된 자동 위험 감지 트리거를 설정할 수 있습니다.',
      sub1: '빠른 설치 완료',
      icon1: IconTagGray,
      sub2: '여러 구역 설정',
      icon2: IconTagGray,
      image: image7,
    },
    {
      title: 'SOP 시나리오 편집 및 현장 맞춤 구성',
      desc: '현장의 특성과 작업 유형에 맞춰 SOP 단계를 편집하거나 새롭게 구성할 수 있습니다. GUI 기반 인터페이스로 누구나 손쉽게 절차를 추가·삭제하며 현장 적용이 가능합니다.',
      sub1: '실시간 시각화',
      icon1: IconShareGray,
      sub2: '여러 구역 설정',
      icon2: IconTagGray,
      image: image8,
    },
  ],
  subfunc: {
    title: '주요기능 요약',
    desc: '작업자의 안전을 보장하는 것은 효율성을 높이고 사고로 인한 손실을 줄입니다. 오브로는 건설 현장 작업자의 안전을 지키기 위해서 최적의 기능들을 구성하였습니다. 작업자가 위험 지역에 다가거나 사고가 발생했을 때, 또는 중장비가 가진 잠재적 위험상황을 포함하여 발생할 수 있는 안전사고에 적절히 대응하도록 시스템을 구축하였습니다.',

    data: [
      {
        icon: IconWarning, // 위험 감지
        title: '실시간 위험 감지',
        desc: '작업자와 환경 센서를 통해 위험 징후를 즉시 감지하고, 알림으로 관리자에게 전송합니다.',
      },
      {
        icon: IconBell, // 알람
        title: 'SOP 자동 실행 기능',
        desc: '위험 발생 시 설정된 SOP 절차가 자동으로 팝업되어, 즉시 대응을 유도합니다.',
      },
      {
        icon: IconDashboard,
        title: '대시보드 통합 모니터링',
        desc: '모든 안전 관련 데이터와 경고 알림을 한눈에 볼 수 있는 대시보드 구성으로 관제 효율을 높입니다.',
      },
      {
        icon: IconBell,
        title: '이상 상황 자동 전송',
        desc: '이상상황 발생시 SMS, 이메일, 모바일 푸시 등을 이용하여 지정된 사용자에게 알림 전송이 가능합니다.',
      },
      {
        icon: IconRoute, // CCTV 연동
        title: 'CCTV 자동 연동',
        desc: '이벤트 발생 시 관련 구역의 CCTV 영상이 자동으로 호출되고 열람 이력이 저장됩니다.',
      },
      {
        icon: IconSearch,
        title: '모바일 대응 시스템',
        desc: 'PC 외에도 모바일로 SOP를 실행할 수 있어, 외부에서도 즉시 대응이 가능합니다.',
      },
      {
        icon: IconChartRadius,
        title: '진행 현황 실시간 표시',
        desc: '현재 어느 SOP가 어떤 단계까지 진행됐는지 대시보드에서 실시간 확인 가능합니다.',
      },
      {
        icon: IconChainLink,
        title: '위험 감지 조건 설정',
        desc: '센서, 위치, 행동 조건을 자유롭게 설정해 복합 상황에 맞는 트리거를 생성할 수 있습니다.',
      },
      {
        icon: IconChartRadius,
        title: '자동 보고서 생성',
        desc: '위험 발생 이력과 대응 내용을 기반으로 PDF 및 엑셀 보고서를 자동 생성할 수 있습니다.',
      },
      {
        icon: IconSecurity,
        title: '감사 및 법적 증빙',
        desc: '모든 이벤트 이력은 자동 저장되어, 향후 외부 감사나 사고 조사 시 활용할 수 있습니다.',
      },
    ],
  },

  system: {
    title: '시스템 구성',
    img: rtlsSystem,
  },

  productTitle: '제품 구성',
  product: [
    {
      tag: 'workerPackage',
    },
    {
      tag: 'assetPackage',
    },
  ],

  contents: [
    {
      data: 'constructionAsset',
    },
    {
      data: 'constructionEquipment',
    },
    {
      data: 'blogRTLS',
    },
    {
      data: 'blogMedical',
    },
  ],
};
